import React, { useState } from "react";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import { Nav, Tab } from "react-bootstrap";
import "./Ensuring_results.css";
import Use_Reference_Material from "./use_Reference_Material/Use_Reference_Material";
import Replicate_Testing from "./replicate_Testing/Replicate_Testing";
import Use_Alternative_Instrument from "./use_Alternative_Instrument/Use_Alternative_Instrument";
import Retesting_Testing from "./retesting_Testing/Retesting_Testing";
import Blind_Sample from "./blind_Sample/Blind_Sample";
import ILC from "./ilc/ILC";
import PT from "./pt/PT";

const Ensuring_results = () => {
  return (
    <section className="Sample_Report">
      <div className="back_div">
        <Common_Back_Btn backText="Ensuring The Validity Of Results" />
      </div>

      <div className="tables_tab_section">
        <Tab.Container
          id="left-tabs-example"
          defaultActiveKey="Use_Reference_Material"
        >
          <Nav variant="pills" className="">
            <Nav.Item>
              <Nav.Link eventKey="Use_Reference_Material">
                Use Of Reference Material
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link eventKey="Use_Alternative_Instrument">
                Use Of Alternative Instrument
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link eventKey="Replicate_Testing">
                Replicate Testing
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link eventKey="Retesting_Testing">
                Retesting Testing
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link eventKey="Blind_Sample">Blind Sample</Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link eventKey="ILC">ILC</Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link eventKey="PT">PT</Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content className="inner-tab-sec">
            <Tab.Pane eventKey="Use_Reference_Material">
              <Use_Reference_Material />
            </Tab.Pane>

            <Tab.Pane eventKey="Use_Alternative_Instrument">
              <Use_Alternative_Instrument />
            </Tab.Pane>

            <Tab.Pane eventKey="Replicate_Testing">
              <Replicate_Testing />
            </Tab.Pane>

            <Tab.Pane eventKey="Retesting_Testing">
              <Retesting_Testing />
            </Tab.Pane>

            <Tab.Pane eventKey="Blind_Sample">
              <Blind_Sample />
            </Tab.Pane>

            <Tab.Pane eventKey="ILC"><ILC/></Tab.Pane>

            <Tab.Pane eventKey="PT"><PT /></Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </section>
  );
};

export default Ensuring_results;
